<div [formGroup]="couponForm" *ngIf="cart$ | async as cart" class="promotion-code d-flex flex-column">
  <input [hidden]="true" formControlName="couponCode"/>
  <div class="price-separator udex-pt-16 udex-mt-20"></div>
  <div class="d-flex flex-grow-1 flex-column flex-sm-row justify-content-between flex-lg-column">
    <label class="promotion-code__label body--xs cx-cart-coupon-title d-flex align-items-center"
    >{{ 'voucher.coupon' | cxTranslate }}
    </label>
    <div
      *ngIf="selectedView === view.Cart && !hideCouponField"
      class="d-flex flex-nowrap flex-grow-1 flex-row udex-mt-12 udex-mt-sm-0 udex-mt-lg-12 justify-content-end"
    >
      <udex-text-field
        label="{{ 'voucher.placeholder' | cxTranslate }}"
        class="promotion-code__input flex-grow-1 udex-pe-12"
        [accessibleName]="'voucher.couponLabel' | cxTranslate"
        [supportingText]="getErrorText() | cxTranslate"
        (input)="onCouponChange($event)"
        [valueState]="hasValidationError() ? 'Error' : 'Standard'"
      ></udex-text-field>
      <udex-button
        class="promotion-code__button"
        (click)="applyVoucher()"
        size="Large"
        design="Secondary"
        [disabled]="cartIsLoading$ | async"
      ><span *ngIf="(couponLoading$ | async) === false; else showSpinner">{{ 'voucher.apply' | cxTranslate }}</span>
        <ng-template #showSpinner>
          <span>
            <ui5-busy-indicator
              size="Medium"
              class="d-flex"
              active
            ></ui5-busy-indicator>
          </span>
        </ng-template>
      </udex-button>
    </div>
  </div>
  <dcp-applied-coupons
    class="flex-grow-1"
    (errorNoCoupon)="onPromoErrorNoCouponCode()"
    [vouchers]="cart.appliedVouchers"
    [cartIsLoading]="cartIsLoading$ | async"
    [isReadOnly]="selectedView !== view.Cart"
  ></dcp-applied-coupons>
</div>
